/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerUpLeft = createReactComponent("corner-up-left", "IconCornerUpLeft", [
  ["path", { d: "M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4", key: "svg-0" }]
]);

export { IconCornerUpLeft as default };
//# sourceMappingURL=IconCornerUpLeft.js.map
